import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import {NpInstanceService} from '../np-instance.service';
import {RouteName} from '../../constants/route.constants';

export const PageResolver: ResolveFn<RouteName> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    npInstanceService: NpInstanceService = inject(NpInstanceService)
): Observable<RouteName> => {
    if (route.url && route.url.length > 0 && route.url[0].path) {
        const currentPage = route.url[0].path as RouteName;
        npInstanceService.setCurrentInstancePage(currentPage);
        return of(currentPage);
    }
    return null;
};
